import $ from 'jquery';
import { removeBlackBars, centerAlignment} from './resizeHelpers';
import { carousels, carousels_mobile } from '../../sections/INF-HeroCarousel/carousel';

const resizeVideo = ($container) => {
  const $player = $container.find('[data-video-player]');
  const $poster = $container.find('[data-video-poster]');
  const container_width = $container.width();
  const container_height = $container.height();
  const screen_ratio = container_width / container_height;
  const aspect_ratio = $container.data('aspectRatio');
  const crop = $container.data('crop');
  let video_width = container_width;
  let video_height = container_height;

  if (crop === true && screen_ratio <= aspect_ratio) {
    // We're cropping the video and our viewable area is narrower than the video, so the height is 100% and width will get cropped
    video_width = container_height * aspect_ratio;
  } else {
    // We're not cropping or we're wider than the video. Either way, width needs to be 100% and height will resize or crop
    video_height = container_width / aspect_ratio;
  }

  let resized_video = removeBlackBars({ original_width: video_width, original_height: video_height, crop, screen_ratio, aspect_ratio });
  // If we're cropping, we need to crop it towards the center (otherwise it will be top/left focused)
  if (crop) {
    resized_video = centerAlignment({ video: resized_video, container_width, container_height });
  }

  $player.width(resized_video.width);
  $player.height(resized_video.height);
  $player.css('margin', `${resized_video.margin_top}px ${resized_video.margin_left}px`);

  if ($poster.data('videoPoster') === 'vimeo') {
    $poster.width(resized_video.width);
    $poster.height(resized_video.height);
    $poster.css('margin', `${resized_video.margin_top}px ${resized_video.margin_left}px`);
    $poster.css('background-size', 'contain');
  }

  if ($poster.data('videoPoster') === 'youtube' && crop) {
    $poster.width(video_width);
    $poster.height(video_height);

    if (video_width > container_width) {
      $poster.css('margin', `0 ${(container_width - video_width) / 2}px`);
    }
  
    if (video_height > container_height) {
      $poster.css('margin', `${(container_height - video_height) / 2}px 0`);
    }
  }

  // Carousel itself has to be resized if we're not cropping since the height of the slides change dynamically
  if (!crop) {    
    const $carousel = $container.closest('[data-hero-carousel]');
    if ($carousel.length > 0) {
      const section_id = $carousel.parent().parent().data('sectionId');

      if (carousels[section_id]) {
        carousels[section_id].resize();
        carousels_mobile[section_id].resize();
      }
    }
  }
};

export default function() {
  $('[data-background-video]').each((i, container) => {
    resizeVideo($(container));
  });
}

export {
  resizeVideo,
};